import React, { useState } from "react"
import styled from "styled-components"
import { useCookies } from 'react-cookie'

import closeGrey from 'images/icon/close_tooltip_grey.png'
import { sendWebViewMsg } from 'utils/bridge'

export default function MainListTab({ currTab = "campaign", setCurrTab }) {
  const [cookies, setCookie, removeCookie] = useCookies()
  const [isMotibellTooltipVisible, setIsMotibellTooltipVisible] = useState(!!cookies['display_motibell_tooltip'])

  const changeCurrTab = (e) => {
    let newTab = e.currentTarget.getAttribute("data-tab")
    if (setCurrTab) {
      setCurrTab(newTab)
    }

    if (newTab === 'motibell' && !!cookies['display_motibell_tooltip']) {
      setIsMotibellTooltipVisible(false)
      removeCookie('display_motibell_tooltip', { path: '/' })
      sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
    }
  }

  return (
    <TabWrapper>
      {currTab === "motibell" ? (
        <>
          <DisabledTab data-tab={`campaign`} onClick={changeCurrTab}>
            <span>루틴 챌린지</span>
          </DisabledTab>
          <ActivatedTab>
            <span>도전 모티벨!</span>
          </ActivatedTab>
        </>
      ) : (
        <>
          <ActivatedTab>
            <span>루틴 챌린지</span>
          </ActivatedTab>
          <DisabledTab data-tab={`motibell`} onClick={changeCurrTab}>
            <MotibellTooltip
              visibility={isMotibellTooltipVisible.toString()}
            >
              🔔 리워드 쏠쏠한 퀴즈!
              <MotibellTooltipClose
                src={closeGrey}
                onClick={(e) => {
                  e.stopPropagation()
                  setIsMotibellTooltipVisible(false)
                  removeCookie('display_motibell_tooltip', { path: '/' })
                  sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
                }}
              />
            </MotibellTooltip>
            <span>도전 모티벨!</span>
          </DisabledTab>
        </>
      )}
    </TabWrapper>
  )
}
const TabWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const ActivatedTab = styled.div`
  position: relative;
  display: inline-block;
  font-weight: bold;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #000000;
  width: 42%;
  text-align: center;
  padding-bottom: calc(100vw * (11 / 375));
  border-bottom: calc(100vw * (3 / 375)) solid;
`

const DisabledTab = styled.div`
  position: relative;
  display: inline-block;
  font-weight: normal;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #4e4e4e;
  width: 42%;
  text-align: center;
  padding-bottom: calc(100vw * (11 / 375));
`

const NewText = styled.span`
  position: absolute;
  font-size: calc(100vw * (12 / 375));
  font-weight: 700;
  color: #fcaf2b;
  top: calc(100vw * (-18 / 375));
  right: calc(100vw * (5 / 375));
`

const MotibellTooltip = styled.div`
  background-color: #FFFFFF;
  color: #4E4E4E;
  position: absolute;
  left: calc(100vw * (-15 / 375));
  bottom: calc(100vw * (45 / 375));
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (17 / 375));
  padding: calc(100vw * (10 / 375));
  border-radius: calc(100vw * (5 / 375));
  box-shadow: 0 calc(100vw * (9 / 375)) calc(100vw * (28 / 375)) calc(100vw * (8 / 375)) rgba(0, 0, 0, 0.05),
    0 calc(100vw * (6 / 375)) calc(100vw * (16 / 375)) rgba(0, 0, 0, 0.08),
    0 calc(100vw * (3 / 375)) calc(100vw * (6 / 375)) calc(100vw * (-4 / 375)) rgba(0, 0, 0, 0.12);

  display: ${({ visibility }) => visibility === 'true' ? 'flex' : 'none'};
  flex-direction: row;
  align-items: center;

  white-space: nowrap;

  &::after {
    content: " ";
    position: absolute;
    bottom: calc(100vw * (-2 / 375));
    left: calc(100vw * (29 / 375));
    border-width: calc(100vw * (6 / 375));
    border-style: solid;
    border-color: #FFFFFF;
    border-top-left-radius: calc(100vw * (2 / 375));
    transform: rotate(45deg);
  }
`

const MotibellTooltipClose = styled.img`
  width: calc(100vw * (7 / 375));
  margin-left: calc(100vw * (7 / 375));
`
